/* ======================================================================== */
/* 66. runOnHighPerformanceGPU */
/* ======================================================================== */
function runOnHighPerformanceGPU() {

	const webGLCanvas = document.getElementById('js-webgl');

	if ( webGLCanvas ) {
		webGLCanvas.getContext('webgl', {
			powerPreference: 'high-performance'
		});
	}

}
